module.exports = __webpack_public_path__ + "img/logo.56181b92.jpg";